module.exports = __webpack_public_path__ + "img/v5.60403c44.png";